import React from "react";

function BtnFooterScoreTable(props) {
  const { isActive } = props;

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="27"
        viewBox="0 0 22 27"
      >
        <g fill="none" fillRule="evenodd">
          <g fill={isActive ? "#FCFCFC" : "#cecdcb"}>
            <g>
              <g>
                <path
                  fillRule="nonzero"
                  d="M9.233 22.531v-4.697c0-.095-.019-.148-.12-.18-1.232-.387-2.312-1.143-3.09-2.165-.736-.946-1.31-2.263-1.48-2.449-.092-.095-.192-.181-.301-.257-1.06-.746-1.996-1.653-2.771-2.688C.807 9.192.281 8.22.082 7.107c-.287-1.595.172-2.92 1.5-3.906.565-.426 1.26-.648 1.972-.63.375 0 .748.074 1.122.115h.115v-.17V.784c.014-.37.277-.684.642-.765C5.51.005 5.589 0 5.667 0H16.32c.24-.005.473.088.642.258.169.17.26.402.25.64v1.8l.265-.047c1.352-.254 2.55.027 3.507 1.044.733.76 1.098 1.797 1.002 2.843-.099 1.07-.468 2.1-1.074 2.991-.793 1.219-1.81 2.28-2.997 3.128-.158.11-.31.23-.452.36-.172.163-1.205 2.25-1.568 2.557-.76.968-1.796 1.688-2.974 2.066-.104.018-.173.115-.157.218v4.634c.03.08.092.142.172.17 4.991.171 4.95 4.314 4.95 4.314-3.681 0-13.86.024-13.86.024.007-.968.277-4.162 5.022-4.332.057 0 .186-.096.186-.137zM4.784 10.465V4.979c-.292-.08-.59-.184-.897-.239-.701-.13-1.391.276-1.614.948-.184.51-.098 1.01.072 1.494.467 1.328 1.367 2.344 2.44 3.283zm12.427-.024c.044-.03.061-.041.077-.055.833-.687 1.527-1.525 2.045-2.47.282-.5.446-1.056.482-1.628.041-.742-.471-1.401-1.205-1.551-.426-.053-.858.019-1.243.206-.106.026-.176.127-.163.235v5.086l.007.177z"
                  transform="translate(-145 -586) translate(145 586)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default BtnFooterScoreTable;
